export var ErrorType;
(function (ErrorType) {
    ErrorType["Request"] = "Request";
    ErrorType["NotAuthorized"] = "NotAuthorized";
    ErrorType["AccessDenied"] = "AccessDenied";
    ErrorType["NotFound"] = "NotFound";
    ErrorType["Server"] = "Server";
    ErrorType["Validation"] = "Validation";
    ErrorType["Offline"] = "Offline";
    ErrorType["Maintenance"] = "Maintenance";
})(ErrorType || (ErrorType = {}));
//# sourceMappingURL=types.js.map